import i18n from "../i18n";

const VideoPlayist = (app) => {
  app
    .post("/video-playlist/save/:id?", async ({ api, flash, req, res }) => {
      const { body, files, params } = req;

      if (params.id) {
        await api(`video-playlist/${params.id}`, {
          method: "PUT",
          body,
          files,
        });
      } else {
        await api("video-playlist", {
          method: "POST",
          body,
          files,
        });
      }

      flash(
        "success",
        i18n.t("coaching-portal:videoPlaylistActions.successfullySaved")
      );

      if (params.id) {
        res.refreshWith(
          { modal: "", playlist: "", video: "", edited: true },
          { url: "back", hash: "#_" }
        );
      } else {
        res.refreshWith(
          { modal: "", playlist: "", video: "", created: true },
          { url: "back", hash: "#_" }
        );
      }
    })
    .get("/video-playlist/delete/:id", async ({ api, flash, req, res }) => {
      const { id } = req.params;

      await api(`video-playlist/${id}`, {
        method: "DELETE",
      });

      flash(
        "success",
        i18n.t("coaching-portal:videoPlaylistActions.successfullyRemoved")
      );

      res.backDontScroll();
    })
    .post(
      "/video-playlist/status/:id",
      async ({ api, assert, flash, req, res }) => {
        const {
          body: { status },
          params: { id },
        } = req;
        const verbs = {
          draft: "unpublish",
          published: "publish",
        };

        const verb = verbs[status];

        assert(
          status,
          400,
          i18n.t("coaching-portal:videoPlaylistActions.statusRequired")
        );
        assert(
          id,
          400,
          i18n.t("coaching-portal:videoPlaylistActions.playlistIdRequired")
        );

        await api(`video-playlist/${id}`, {
          method: "PUT",
          body: { status },
        });

        flash(
          "success",
          i18n.t("coaching-portal:videoPlaylistActions.successfullyVerbed", {
            verb,
          })
        );

        res.refreshWith({}, { url: "back", hash: "#_" });
      }
    )
    .post(
      "/video-playlist/reorder",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        assert(
          body.orderedPlaylists,
          400,
          i18n.t(
            "coaching-portal:videoPlaylistActions.provideOrderedPlaylists"
          )
        );

        await api("video-playlist-reorder", {
          method: "PUT",
          body,
        });

        flash(
          "success",
          i18n.t("coaching-portal:videoPlaylistActions.successfullyReordered")
        );
        res.backDontScroll();
      }
    );
};

export default VideoPlayist;
